const allQuestions = [
    {
      "id": 1,
      "realPrompt": "What's your favorite color?",
      "imposterPrompt": "What's the most common color?"
    },
    {
      "id": 2,
      "realPrompt": "What's your favorite animal?",
      "imposterPrompt": "What's a commonly loved animal?"
    },
    {
      "id": 3,
      "realPrompt": "What’s your favorite food?",
      "imposterPrompt": "What’s the most popular food?"
    },
    {
      "id": 4,
      "realPrompt": "What’s your favorite movie?",
      "imposterPrompt": "What’s a popular movie everyone knows?"
    },
    {
      "id": 5,
      "realPrompt": "Where did you go for your last vacation?",
      "imposterPrompt": "Where do you think most people go for vacations?"
    },
    {
      "id": 7,
      "realPrompt": "What’s your dream job?",
      "imposterPrompt": "What job is most in demand?"
    },
    {
      "id": 9,
      "realPrompt": "What’s your favorite hot beverage?",
      "imposterPrompt": "What’s the most common beverage?"
    },
    {
      "id": 10,
      "realPrompt": "What’s your favorite TV show?",
      "imposterPrompt": "What TV show is trending right now?"
    },
    {
      "id": 11,
      "realPrompt": "How many cups of coffee do you drink per day?",
      "imposterPrompt": "Put a number between 0 and 10"
    },
    {
      "id": 12,
      "realPrompt": "How many hours of sleep did you get last night?",
      "imposterPrompt": "Put a number between 0 and 12"
    },
    {
      "id": 13,
      "realPrompt": "How many times have you flown on an airplane?",
      "imposterPrompt": "Put a number between 0 and 100"
    },
    {
      "id": 14,
      "realPrompt": "How many unread messages are on your phone?",
      "imposterPrompt": "Put a number between 0 and 500"
    },
    {
      "id": 15,
      "realPrompt": "How many times a week do you exercise?",
      "imposterPrompt": "Put a number between 0 and 14"
    },
    {
      "id": 16,
      "realPrompt": "How many apps do you have on your phone?",
      "imposterPrompt": "Put a number between 10 and 200"
    },
    {
      "id": 18,
      "realPrompt": "How many countries have you visited?",
      "imposterPrompt": "Put a number between 0 and 30"
    },
    {
      "id": 19,
      "realPrompt": "How many languages can you speak?",
      "imposterPrompt": "Put a number between 1 and 10"
    },
    {
      "id": 22,
      "realPrompt": "How many siblings do you have?",
      "imposterPrompt": "Put a number between 0 and 10"
    },
    {
      "id": 23,
      "realPrompt": "How many jobs have you had?",
      "imposterPrompt": "Put a number between 0 and 10"
    },
    {
      "id": 24,
      "realPrompt": "How many times a week do you cook at home?",
      "imposterPrompt": "Put a number between 0 and 15"
    },
    {
      "id": 25,
      "realPrompt": "How many hours a day do you spend online?",
      "imposterPrompt": "Put a number between 0 and 24"
    },
    {
      "id": 26,
      "realPrompt": "How many steps o you take on average?",
      "imposterPrompt": "Put a number between 0 and 25000"
    },
    {
      "id": 27,
      "realPrompt": "How many books did you read last year?",
      "imposterPrompt": "Put a number between 0 and 50"
    },
    {
      "id": 28,
      "realPrompt": "How many people live in your home?",
      "imposterPrompt": "Put a number between 1 and 15"
    },
    {
      "id": 29,
      "realPrompt": "How many alarms do you set in the morning?",
      "imposterPrompt": "Put a number between 0 and 50"
    },
    {
      "id": 30,
      "realPrompt": "How many tabs do you currently have open in your browser?",
      "imposterPrompt": "Put a number between 1 and 100"
    },
    {
      "id": 31,
      "realPrompt": "What's your favorite holiday?",
      "imposterPrompt": "What's the most celebrated holiday?"
    },
    {
      "id": 32,
      "realPrompt": "What do you enjoy doing on weekends?",
      "imposterPrompt": "What do most people enjoy doing on weekends?"
    },
    {
      "id": 33,
      "realPrompt": "What type of music do you listen to the most?",
      "imposterPrompt": "What type of music is the most popular?"
    },
    {
      "id": 34,
      "realPrompt": "What’s your favorite sport?",
      "imposterPrompt": "What sport is most popular in the world?"
    },
    {
      "id": 35,
      "realPrompt": "What’s your favorite social media platform?",
      "imposterPrompt": "What’s the most popular social media platform?"
    },
    {
      "id": 36,
      "realPrompt": "What’s your go-to snack?",
      "imposterPrompt": "What’s a popular snack?"
    },
    {
      "id": 37,
      "realPrompt": "What’s a pet you don't like?",
      "imposterPrompt": "Name a pet?"
    },
    {
      "id": 38,
      "realPrompt": "What’s your favorite type of weather?",
      "imposterPrompt": "What’s the most common weather?"
    },
    {
      "id": 39,
      "realPrompt": "What’s your favorite type of movie?",
      "imposterPrompt": "What type of movie is the most popular?"
    },
    {
      "id": 41,
      "realPrompt": "What’s your ideal weekend getaway?",
      "imposterPrompt": "Where do most people go for a weekend getaway?"
    },
    {
      "id": 43,
      "realPrompt": "How do you prefer to spend your free time?",
      "imposterPrompt": "What do most people do in their free time?"
    },
    {
      "id": 44,
      "realPrompt": "What’s your favorite drink?",
      "imposterPrompt": "What drink is the most popular?"
    },
    {
      "id": 45,
      "realPrompt": "What’s your favorite activity to do with friends?",
      "imposterPrompt": "What do most people enjoy doing with friends?"
    },
    {
      "id": 46,
      "realPrompt": "Do you prefer mornings or nights?",
      "imposterPrompt": "Name part of day."
    },
    {
      "id": 47,
      "realPrompt": "Which season do you like?",
      "imposterPrompt": "Name a season."
    },
    {
      "id": 48,
      "realPrompt": "What’s your favorite ice cream flavor?",
      "imposterPrompt": "What’s the most popular ice cream flavor?"
    },
    {
      "id": 49,
      "realPrompt": "What’s your favorite sport to watch?",
      "imposterPrompt": "Name a sport."
    },
    {
      "id": 51,
      "realPrompt": "What’s your favorite time of day?",
      "imposterPrompt": "Pick time of day."
    },
    {
      "id": 52,
      "realPrompt": "What’s your favorite vacation destination?",
      "imposterPrompt": "Where do most people like to vacation?"
    },
    {
      "id": 53,
      "realPrompt": "What’s your favorite genre of books?",
      "imposterPrompt": "What genre of books is the most people read?"
    },
    {
      "id": 54,
      "realPrompt": "What’s your least favorite exercise?",
      "imposterPrompt": "What’s the most popular exercise?"
    },
    {
      "id": 55,
      "realPrompt": "What’s your least favorite childhood memory?",
      "imposterPrompt": "What memory do most people treasure?"
    },
    {
      "id": 56,
      "realPrompt": "What’s your favorite board game?",
      "imposterPrompt": "What’s the most popular board game?"
    },
    {
      "id": 57,
      "realPrompt": "What’s your favorite type of candy?",
      "imposterPrompt": "Nmae a candy"
    },
    {
      "id": 59,
      "realPrompt": "What’s your favorite way to relax?",
      "imposterPrompt": "What’s the most common way to relax?"
    },
    {
      "id": 61,
      "realPrompt": "What’s your favorite city to visit?",
      "imposterPrompt": "Name a city."
    },
    {
      "id": 62,
      "realPrompt": "What’s your favorite type of cuisine?",
      "imposterPrompt": "What’s the most common cuisine?"
    },
    {
      "id": 63,
      "realPrompt": "What’s your favorite outdoor activity?",
      "imposterPrompt": "What’s the most popular outdoor activity?"
    },
    {
      "id": 64,
      "realPrompt": "What’s your favorite childhood toy?",
      "imposterPrompt": "What’s the most common childhood toy?"
    },
    {
      "id": 65,
      "realPrompt": "What’s your favorite form of entertainment?",
      "imposterPrompt": "What’s the most popular form of entertainment?"
    },
    {
      "id": 66,
      "realPrompt": "What’s your favorite type of weather?",
      "imposterPrompt": "What’s the most common weather?"
    },
    {
      "id": 68,
      "realPrompt": "What’s your favorite indoor activity?",
      "imposterPrompt": "What’s the most common indoor activity?"
    },
    {
      "id": 70,
      "realPrompt": "What’s your least favorite type of ice cream?",
      "imposterPrompt": "What’s the most common ice cream flavor?"
    }
  ];

  export default allQuestions;
  